export default () => ({
  scrollIntoViewWithOffset(selector, offset) {
    this.$nextTick(() => {
      window.scrollTo({
        behavior: 'smooth',
        top:
          this.$refs[selector].getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          offset,
      })
    })
  },
})
